module.exports = __webpack_public_path__ + "img/codwarzone-logo.9caf2641.png";